module.exports = __webpack_public_path__ + "static/img/samajuri (14).b8b826a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/samajuri/samajuri (14).jpg
// module id = G2fD
// module chunks = 0